define('Printedposter.ei1.Main', [
  
    'Inspiredspace.ei1.Main.View',
    'Design.ei1.Main.View'
], function (
  
  
    InspiredspaceMainView,
   
    DesignMainView
) {
    'use strict';

    return {
        mountToApp: function (container) {
            var PageType = container.getComponent('PageType');

            jQuery(document).unbind('ajaxStart', SC.loadingIndicatorShow);
            jQuery(document).unbind('ajaxStop', SC.loadingIndicatorHide);
            jQuery('#loadingIndicator').remove();

             PageType.registerPageType({
                name: 'inspired_space.tpl',
                routes: ['inspired'],
                view: InspiredspaceMainView,
                defaultTemplate: {
                    name: 'inspired_space.tpl',
                    displayName: 'Inspired Space'
                }
            });
          
             PageType.registerPageType({
                name: 'design.tpl',
                routes: ['design'],
                view: DesignMainView,
                defaultTemplate: {
                    name: 'design.tpl',
                    displayName: 'Design'
                }
            });
        }
    }
});
